import { Component, Input, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { PersonGbMasterDetailEntryMeta, PersonGbRolleMitRecht, PersonGbVersionDetailEntryMeta } from '../../../../core/gb-api';
import { ComponentLocationStrategy } from '../../../../shared/services/location-strategy/component-location-strategy';
import { PersonGbDetailLocationStrategy } from '../../../../shared/services/location-strategy/person-gb-detail-location-strategy';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktGrundstueckComponent } from '../../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktStandardrechtComponent } from '../../../../shared/kompaktdarstellung/standardrecht/kompakt-standardrecht.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktGrundpfandrechtComponent } from '../../../../shared/kompaktdarstellung/grundpfandrecht/kompakt-grundpfandrecht.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-persongb-rolle',
  templateUrl: './persongb-rolle.component.html',
  providers: [{ provide: ComponentLocationStrategy, useClass: PersonGbDetailLocationStrategy }],
  imports: [
    KopfdatenelementComponent,
    HistoryDirective,
    KompaktGrundstueckComponent,
    KompaktStandardrechtComponent,
    NgTemplateOutlet,
    KompaktGrundpfandrechtComponent,
    TranslatePipe
  ]
})
export class PersongbRolleComponent implements OnInit {
  rolle: PersonGbRolleMitRecht;

  @Input()
  master: PersonGbMasterDetailEntryMeta;
  @Input()
  version: PersonGbVersionDetailEntryMeta;

  RolleEnum = PersonGbRolleMitRecht.RolleEnum;

  constructor() {
    keysToTranslate(['Eintragung']);
  }

  ngOnInit() {
    this.rolle = this.master.rolleMitRecht;
  }
}
